import { XStack } from '@frontend/web-react';
import type { ClassName } from '@frontend/web-utils';
import { concatClasses } from '@frontend/web-utils';
import { TabPill } from './TabPill';

type TabItem<Key extends string = string> = {
  key: Key;
  label: string;
};

type TabPillListProps<Key extends string> = {
  activeKey: Key;
  className?: ClassName;
  onTabChange: (key: Key) => void;
  tabs: readonly TabItem<Key>[];
};

export const TabPillList = <Key extends string>({ activeKey, className, onTabChange, tabs }: TabPillListProps<Key>) => (
  <XStack accessibilityLabel="Tab selection list" className={concatClasses('gap-sm', className)} role="listbox">
    {tabs.map((tab) => (
      <TabPill isActive={tab.key === activeKey} key={tab.key} label={tab.label} onClick={() => onTabChange(tab.key)} />
    ))}
  </XStack>
);
